export default __webpack_public_path__ + "static/media/Left side Pic.953032be.png";